<div *transloco="let t; read: TRANSLATION_SCOPE" [formGroup]="parentForm">
  <ng-container *ngIf="hasSpecialRequest">
    <h3 class="mb-3">
      {{ t('header') }}
    </h3>
    <div class="card-shadow">
      <div class="row pt-2">
        <div class="col-md-12 f-family-bold">
          {{ t('anyCustomRequest.question') }}
        </div>

        <ng-container *ngIf="loyaltyViaSpecialRequest$ | async">
          <p class="col-sm-8">
            <small [innerHtml]="t('anyCustomRequest.questionNotice')"></small>
          </p>

          <p *ngIf="isCustomRequestVisible" @collapseExpand class="col-sm-8">
            <small [innerHtml]="t('anyCustomRequest.loyaltyNotice')"></small>
          </p>
        </ng-container>

        <div class="col-md-12 pt-3" *ngIf="yesNoOptions$ | async as yesNoOptions">
          <rx-radio
            class="radio-inline"
            [options]="yesNoOptions"
            label="radio default label"
            name="specialRequestChoice"
            (toggle)="toggleCustomRequest()"
          ></rx-radio>
        </div>
      </div>
      <div class="row" *ngIf="isCustomRequestVisible" @collapseExpand>
        <div class="col-sm-8">
          <p *ngIf="(loyaltyViaSpecialRequest$ | async) === false">
            <small [innerHtml]="t('anyCustomRequest.notice')"></small>
          </p>
          <rx-textarea formControlName="customRequest" maxlength="500">
            <rx-validation-messages
              rx-error
              field="customRequest"
              [form]="parentForm"
              [translationsPath]="doTranslate('anyCustomRequest.errors')"
            ></rx-validation-messages>
          </rx-textarea>
        </div>
      </div>
    </div>
    <hr />
  </ng-container>
</div>
